export const CACHE_TIME =
  process.env.NODE_ENV === "test" ? Infinity : 1000 * 60 * 5
